import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { DOCSIGN_API_ERROR_CODES, DOCSIGN_CONSTANTS, PAGE } from '../../../constants';
import Guid from '../../../utils/guid';
import { DOCSIGN_PATH } from './docsign-muster-constants';

export default () => {
  return muster()
    .path('docsign.getDocumentList', {
      call: async ({ req }, { get, set }) => {
        await set('docsign.gettingDocuments', true);
        await set('docsign.documentList', []);
        await set('docsign.errorMessage', null);
        await set('app.user.cacheId', Date.now());

        const [messages] = await getValues(get('i18n.messages'));
        const status = req.args[0];
        const pageNumber = req.args[1];
        const pageSize = PAGE.pageSize;
        const inputs = `${status}#@#${pageNumber}#@#${pageSize}`;
        const guidStr = Guid();

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getDocumentList["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (response) => {
          await set('docsign.gettingDocuments', false);

          if (response.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT ||
            response.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsign.errorMessage', null);

            await set('docsign.documentListResponse', response.data);
            const documents = response.data.docuListStatusResponse.content;
            // if (status === DOCSIGN_CONSTANTS.PENDING_ACTION) {
            //   documents.sort((a, b) => a.targetDate > b.targetDate);
            // } else {
            //   documents.sort((a, b) => a.modifiedDate < b.modifiedDate);
            // }
            await set('docsign.documentList', documents);

          } else if (response.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST_INT ||
            response.returnCode === DOCSIGN_API_ERROR_CODES.EMPTY_DOCUMENT_LIST) {
            let errorMessage = messages['app.docusign.emptyPendingDocumentsText'];
            if (status === DOCSIGN_CONSTANTS.OTHERS) {
              errorMessage = messages['app.docusign.emptyOtherDocumentsText'];
            }

            await set('docsign.errorMessage', errorMessage);
          }

        }).catch(async () => {
          await set('docsign.gettingDocuments', false);
          await set('docsign.errorMessage', messages['app.digisign.error.tryagain']);
        });
      }
    })

    .path('docsign.resetVariables', {
      call: async ({ req }, { set }) => {
        await set('docsign.documentListResponse', undefined);
        await set('docsign.documentList', []);
        await set('docsign.gettingDocuments', true);
        await set('docsign.errorMessage', null);
      }
    })

    .path('docsign.setPageParams', {
      call: async ({ req }, { set }) => {
        await set('docsign.pageNumber', req.args[0].pageNumber);
        await set('docsign.pageOffset', req.args[0].pageOffset);
      }
    })

    .path('docsign.documentListResponse', variable(undefined))
    .path('docsign.documentList', variable([]))
    .path('docsign.gettingDocuments', variable(true))
    .path('docsign.errorMessage', variable(null))
    .path('docsign.pageNumber', variable())
    .path('docsign.pageOffset', variable());
};